import React from 'react';
import TeamMembers from '../TeamMembers/TeamMembers';

const Team = () => {
    return (
        <div>
            <TeamMembers />
        </div>
    );
};

export default Team;